<ui-modal [open]="open()" [title]="title()" size="sm" (close)="onCancel()">
  <div class="ui-confirm">
    <div class="ui-confirm__icon ui-confirm__icon--{{ tone() }}" aria-hidden="true">
      <ui-icon name="alert" />
    </div>
    <p class="ui-confirm__message">{{ message() }}</p>
  </div>
  <div modal-footer class="ui-confirm__footer">
    <ui-button variant="outline" (click)="onCancel()">{{ cancelLabel() }}</ui-button>
    <ui-button
      [variant]="tone() === 'danger' ? 'danger' : 'primary'"
      [loading]="loading()"
      (click)="confirm.emit()"
    >
      {{ confirmLabel() }}
    </ui-button>
  </div>
</ui-modal>
